<template>
  <div :class="`five-selector-${count}`">
    <div class="selectors">
      <div v-for="n in titles.length"
           :class="classesFor(n)"
           :title="tips ? $t(tips + '.' + n) : ''"
           data-toggle="tooltip"
           data-placement="top"
           @click="updateSelection(n)">
        {{ titles[n - 1] }}
      </div>
      <div v-if="noAnswer"
           :class="{ 'active': this.selected == 7 }"
           :title="tips ? $t(tips + '.7') : ''"
           class="selector selector-7"
           data-toggle="tooltip"
           data-placement="top"
           @click="updateSelection(7)">
        <fa icon="times" />
      </div>
      <div :style="`margin-left: ${42 * (selected - 1) + (42 / 2)}px`" class="arrow"/>
    </div>
    <div v-if="showTips" class="tips">
      <small class="float-left">{{ $t(`${tips}.1`) }}</small><small class="float-right">{{ $t(`${tips}.5`) }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FiveSelector',

  props: {
    id: { type: String, default: null },
    noAnswer: { type: Boolean, default: true }, // Add 'X' option at the end.
    offset: { type: Number, default: 0 }, // Values offset.
    readonly: { type: Boolean, default: false },
    showTips: { type: Boolean, default: false },
    tips: { type: String, default: null },
    unknown: { type: Boolean, default: true }, // Add '?'' option at the end.
    value: { type: Number, default: 0 }
  },

  data: () => ({
    selected: this.value
  }),

  computed: {
    count () {
      return 5 + (this.unknown ? 1 : 0) + (this.noAnswer ? 1 : 0)
    },

    titles () {
      const choices = ['?']

      for (var i = 5; i >= 1; i--) {
        choices.splice(0, 0, i + this.offset)
      }

      return this.unknown ? choices : choices.slice(0, choices.length - 1)
    }
  },

  mounted () {
    this.selected = this.value
  },

  methods: {
    classesFor (n) {
      let classes = {}

      classes['selector'] = true
      classes['selector-' + n] = true
      classes['active'] = this.selected == n

      return classes
    },

    updateSelection (val) {
      if (!this.readonly) {
        this.selected = val // Values stays between 1 and 7, offset is not applied.
        this.$emit('input', this.selected)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ../../../../resources/js/components/FiveSelector.vue